// extracted by mini-css-extract-plugin
export var active = "_37-2";
export var errorDot = "_37-3";
export var sideNavContainer = "_37-0";
export var sideNavLink = "_37-1";